import React from 'react';

const Section = props => {
  return <div className={props.className || ''}>
    {props.formattedTitle || <h4>{props.title}</h4>}
    <hr />
    <div className={props.noMargin ? '' : 'ms-md-5'}>
      {props.children}
    </div>
  </div>;
};

export default Section;
